import { useParams } from "react-router-dom";
import CityPage from "@/pages/seo/CityPage";
import RoutePage from "@/pages/seo/RoutePage";
import ServicePage from "@/pages/seo/ServicePage";
import RegionPage from "@/pages/seo/RegionPage";
import NotFoundPage from "@/pages/NotFoundPage";
import { getMainServiceBySlug } from "@/data/seo/mainServices";
import { getRegionPageBySlug } from "@/data/seo/regionPages";
import { getRouteBySlug } from "@/data/seo/routes";
import { getCityBySlug, EXTERNAL_PLACES } from "@/data/seo/cities";

/**
 * Single smart resolver for the whole programmatic SEO architecture.
 * URL patterns handled:
 *  - /{main-service-slug}            -> ServicePage   (e.g. /transport-de-meubles, /petit-demenagement)
 *  - /{region-page-slug}             -> RegionPage     (e.g. /transport-normandie)
 *  - /transport-{ville-a}-{ville-b}  -> RoutePage      (e.g. /transport-le-havre-rouen)
 *  - /transport-{ville}              -> CityPage       (e.g. /transport-rouen)
 * This keeps every combination reachable (architecture ready for full scale) while
 * indexability of each page is controlled independently via each entity's `isPhase1` flag.
 */
export default function SEOResolverPage() {
  const { slug } = useParams();

  if (getMainServiceBySlug(slug)) return <ServicePage serviceSlug={slug} />;
  if (getRegionPageBySlug(slug)) return <RegionPage regionSlug={slug} />;

  if (slug.startsWith("transport-")) {
    const remainder = slug.replace(/^transport-/, "");
    if (getRouteBySlug(remainder)) return <RoutePage routeSlug={remainder} />;
    if (getCityBySlug(remainder) || EXTERNAL_PLACES[remainder]) return <CityPage citySlug={remainder} />;
  }

  return <NotFoundPage />;
}
